import { format, parse } from "date-fns";

import {
  PlaneDepartureIcon,
  PlaneArrivalIcon,
  UsersIcon,
  CoinIcon,
} from "components/Icons";
import { cn } from "tools/ui";

const FORMAT = "dd.MMM";

const base =
  "bg-white m-1 pt-2 px-4 shadow-md inline-block h-38 w-full md:w-56 cursor-pointer rounded-2xl border border-white shadow-neutral-300 overflow-hidden active:scale-95 active:shadow-xl";
const divHead = "flex text-neutral-800 justify-between";
const divContent = "h-fit py-1 text-neutral-600 text-sm";

function CardFolio({ record, layout, onClick }) {
  const { model, card_action = [] } = layout;

  const key = record.id;

  let clickable = "";
  const selectable = card_action.includes("open");
  if (selectable) {
    clickable = "cursor-pointer active:scale-95 active:shadow-xl";
  }

  let actionDelete = false;
  if (card_action) {
    for (const action of card_action) {
      if (action === "delete") {
        actionDelete = true;
      }
    }
  }

  function handleClick() {
    onClick(record);
  }

  const state = `${model}.${record.registration_state}`;
  const arrival_date = format(
    parse(record.arrival_date, "yyyy-MM-dd", new Date()),
    FORMAT,
  );
  const departure_date = format(
    parse(record.departure_date, "yyyy-MM-dd", new Date()),
    FORMAT,
  );

  const { payments, rec_name: bkNumber } = record["booking."];
  const hasPayments = payments.length > 0;
  let holder = record["booking."].contact;
  if (record["booking."]["party."]?.name) {
    holder = record["booking."]["party."].name;
  }
  return (
    <div key={key} className={cn(base, clickable)} onClick={handleClick}>
      <div className={divHead}>
        <div className="font-bold text-md">{record["room."].rec_name}</div>
        <span className="text-xs text-neutral-400">{bkNumber}</span>
      </div>
      <div className={divContent}>
        <div className="flex truncate font-bold text-xs text-neutral-400 mb-4 justify-between">
          <span>{record["product."].name}</span>
          {hasPayments && (
            <CoinIcon className="h-4 text-teal-500 my-auto fill-current" />
          )}
        </div>
        <div className="flex my-2 text-xs text-neutral-600">
          <PlaneArrivalIcon className="h-5 text-yellow-700 fill-current" />
          <span className="ml-3 mr-auto">{arrival_date}</span>
          <span className="mx-auto">|</span>
          <span className="ml-auto mr-3">{departure_date}</span>
          <PlaneDepartureIcon className="h-5 text-yellow-700 fill-current" />
        </div>
        <div className="flex mt-3 justify-between">
          <div className="flex my-auto">
            <UsersIcon className="h-4 text-sky-600/50 my-auto fill-current" />
            <span className="ml-1 text-neutral-700 text-sm">{record.pax}</span>
          </div>
          <span className="text-sm my-auto text-neutral-500">
            {record.nights_quantity} noc
          </span>
        </div>
        <div className="flex">
          <span className="mt-1 font-bold truncate">{holder}</span>
        </div>
      </div>
    </div>
  );
}

export default CardFolio;
